import classNames from 'classnames'
import * as PropTypes from 'prop-types'
import React from 'react'

import { SectionContainer } from '../../../components'
import { HorizontalTextAnimated } from '../../../components'
import { colors } from '../../../theme'
import { chainDecorators, memoized } from '../../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

const gradientColor = [18, 26, 76]

function HomeBrands({ className, t }) {

  return (
      <>
        <SectionContainer className={classNames('brands', className)}>
          <div className="wrapper-brands">
            <HorizontalTextAnimated className="first-line" text={t('homeBrandsFirstLine')} marqueeProps={{  gradientColor  }} />
            <HorizontalTextAnimated className="second-line" text={t('homeBrandsSecondLine')} marqueeProps={{ direction: 'right', gradientColor }} />
            <HorizontalTextAnimated className="third-line" text={t('homeBrandsThirdLine')} marqueeProps={{  gradientColor }} />
          </div>
        </SectionContainer>
        <style jsx>{styles}</style>
      </>
    )
}

HomeBrands.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
}

HomeBrands.defaultProps = {
  className: '',
  t: () => null
}

HomeBrands = chainDecorators(decorators, HomeBrands)

export default HomeBrands
